var map = {
	"./arrow_down.svg": 96,
	"./arrow_left.svg": 97,
	"./arrow_right.svg": 98,
	"./arrow_up.svg": 99,
	"./camera.svg": 100,
	"./car.svg": 101,
	"./cart.svg": 102,
	"./catalog_view_card.svg": 103,
	"./catalog_view_table.svg": 104,
	"./catalog_view_tile.svg": 105,
	"./checkbox.svg": 106,
	"./close.svg": 107,
	"./filters.svg": 108,
	"./geo.svg": 109,
	"./hamburger.svg": 110,
	"./info.svg": 111,
	"./mail.svg": 112,
	"./phone.svg": 113,
	"./profile.svg": 114,
	"./radio-checked.svg": 115,
	"./radio.svg": 116,
	"./search.svg": 117,
	"./viber.svg": 118,
	"./whatsapp.svg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;